import { Pipe, PipeTransform } from '@angular/core';

import { CommonService } from '../services/common.service';

@Pipe({
  name: 'filterTextTransform',
})
export class FilterTextTransformPipe implements PipeTransform {
  constructor(private cService: CommonService) {}

  transform(dataText: string) {
    const translation = this.cService.getSingleTranslation(`COURSES.${dataText}`, dataText);

    if (translation !== dataText) {
      return translation;
    }

    return this.cService.readyTranslations.courses[dataText]
      ? this.cService.readyTranslations.courses[dataText]
      : this.cService.getTextFromNavigationFilterTexts(dataText);
  }
}
